import { createBrowserHistory, History } from 'history';

export const history = createBrowserHistory();

// Disable automatic scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

export const getHistory = (): History => {
  return history;
};
